import { useQuery } from "@apollo/client";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";

import { GET_TRANSACTION_LIST } from "../../graphql/queries/transaction";
import TransactionListTable from "./components/TransactionListTable";
import { showErrorToast } from "../../components/common/CustomErrorMessage";

const Transaction = () => {
  const transaction = useSelector((state) => state.transaction);
  const { transactions } = transaction;
  const {
    data: { getTransactionList } = {},
    loading,
    refetch,
  } = useQuery(GET_TRANSACTION_LIST, {
    variables: { action: transactions.action },
    onError(er) {
      showErrorToast(er.message);
    },
  });

  return (
    <Card className="lao">
      <Card.Header>
        <Card.Title>
          <h3 className="p-1">ລາຍການທຸລະກຳ</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <TransactionListTable
          data={getTransactionList}
          loading={loading}
          refetch={refetch}
        />
      </Card.Body>
    </Card>
  );
};

export default Transaction;
